// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tdt-container[data-v-2c5f7d52]{width:100%;height:480px;border-radius:5px;overflow:hidden;position:relative}.tdtMapView[data-v-2c5f7d52]{width:100%;height:100%;z-index:1}.tdtMapOverlay[data-v-2c5f7d52]{position:absolute;top:0;left:0;z-index:3;font-size:16px;color:red;transform:translateY(-100%)}", ""]);
// Exports
module.exports = exports;
